import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import InputSearchField from './../../component/inputSearchField';
import AdHocViewEnum from './adHocViewEnum';
import Select from './../../component/select';
import SelectCountryField from './../../component/selectCountryDropdown';

class TableView extends Component {
    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = this._createSearchParamsObject();
        Service.fetchAdHocReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    _callServiceDownloadFile() {
        var searchParams = this._createSearchParamsObject();
        Service.downloadAdHocReport(searchParams, this.viewType);
    }

    _createSearchParamsObject(page) {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        searchParams.shipDateStart = this.shipDateStart;
        searchParams.shipDateEnd = this.shipDateEnd;
        searchParams.openSearch = this.searchInputFieldValue;
        searchParams.searchStatus = this.statusDropdownValue;
        searchParams.languagePreference = this.languagePreferenceDropdownValue;
        searchParams.countryDropdownValue = this.countryDropdownValue;
        searchParams.searchWithOrWithoutShipments = this.withOrWithoutShipmentsDropdownValue;

        return searchParams;
    }
    // END private methods

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Ad Hoc Accounts",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.searchInputFieldValue = "";
        this.viewType = AdHocViewEnum.ACCOUNT;
        this.statusDropdownValue = "";
        this.languagePreferenceDropdownValue = "";
        this.countryDropdownValue = "";
        this.withOrWithoutShipmentsDropdownValue = "";
        this.tableHeaderColumnList = [
            { columnName: "Account Id", key: "accountId"},
            { columnName: "First Name", key: "firstName"},
            { columnName: "Last Name", key: "lastName"},
            { columnName: "Date Join", key: "createdDate"},
            { columnName: "Locker", key: "lockerCode"},
            { columnName: "Country", key: "countryName"},
            { columnName: "Status", key: "status"},
            { columnName: "Language Preference", key: "languagePreference"},
            { columnName: "Total Sent Shipments", key: "sentShipments"},
            { columnName: "Total Revenue", key: "totalRevenue"},
        ]
    }

    componentDidMount () {
        var fetchEventForResultData = Service.getEventSignal(this.viewType);
        fetchEventForResultData.add((data) => {
            console.log("*** fetchEventForResultData");
            console.log(data);
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    onShippedStartDateFieldChange = (value) => {
        this.shipDateStart = value;
    };

    onShippedEndDateFieldChange = (value) => {
        this.shipDateEnd = value;
    };

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    onSearchFieldChange = (value) => {
        this.searchInputFieldValue = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    handleStatusDropdownChange = (event) => {
        this.statusDropdownValue = event.target.value;
    };

    handleWithOrWithoutShipmentsDropdownChange = (event) => {
        this.withOrWithoutShipmentsDropdownValue = event.target.value;
    };

    handleLanguagePreferenceDropdownChange = (event) => {
        this.languagePreferenceDropdownValue = event.target.value;
    };

    handleCountryDropdownChange = (value) => {
        this.countryDropdownValue = value;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        type = "adHocReport"
                    >
                        <SelectCountryField name="statusDropdown" className={"search-country-field packages-status-dropdown"}
                                controlFunc={this.handleCountryDropdownChange}
                        />
                        <Select name="statusDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handleStatusDropdownChange}
                                options = {Utils.statusDropdownOptions}
                        />
                        <Select name="withOrWithoutShipmentsDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handleWithOrWithoutShipmentsDropdownChange}
                                options = {Utils.withOrWithoutShipmentsDropdownOptions}
                        />
                        <Select name="languagePreferenceDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handleLanguagePreferenceDropdownChange}
                                options = {Utils.languagePreferenceDropdownOptions}
                        />
                        <DatePicker
                            fieldId = "adHocAccountStartDatePicker"
                            placeHolderText = "Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocAccountEndDatePicker"
                            placeHolderText = "End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                        <DatePicker
                            fieldId = "adHocAccountShippedStartDatePicker"
                            placeHolderText = "Ship Start Date"
                            onChange = {this.onShippedStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocAccountShippedEndDatePicker"
                            placeHolderText = "Ship End Date"
                            onChange = {this.onShippedEndDateFieldChange}
                            fieldType = "endDate"
                        />
                        <InputSearchField
                            fieldId = "adHocSearchField"
                            placeHolderText = "Search"
                            onChange = {this.onSearchFieldChange}
                        />
                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >

                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;